import React from "react";
import { cn } from "../../../lib/utils";

export interface CommentButtonProps {
  count?: number;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
}

export const CommentButton: React.FC<CommentButtonProps> = ({
  count,
  onClick,
  disabled = false,
  className,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={cn(
        `
        relative
        flex items-center justify-center
        w-[34px] h-[34px]
        box-content
        border border-[#3551F3]
        rounded-[8px]
        shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)]
        disabled:opacity-70 disabled:cursor-not-allowed
        transition-all
        `,
        className
      )}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          d="M14 10C14 10.3536 13.8595 10.6928 13.6095 10.9428C13.3594 11.1929 13.0203 11.3333 12.6667 11.3333H4.66667L2 14V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H12.6667C13.0203 2 13.3594 2.14048 13.6095 2.39052C13.8595 2.64057 14 2.97971 14 3.33333V10Z"
          stroke="#3551F3"
          strokeWidth="1.33"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>

      {!!count && (
        <div
          className="
            absolute 
            -top-[8px] -right-[13px] 
            h-4 min-w-[20px] 
            px-1 py-0
            flex items-center justify-center 
            bg-[#3551F3] 
            rounded-full 
            border border-transparent
            z-10
          "
        >
          <span
            className="
              font-sans 
              text-[12px] 
              font-semibold 
              leading-4 
              text-[#FAFAFA]
            "
          >
            {count}
          </span>
        </div>
      )}
    </button>
  );
};
